import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import BreadcrumbsAuto from "./breadcrumbs-auto";

export default function TitleBar({
	title,
	impersonate_section = null,
	tooltip = null,
	actions = null,
	navbar = null,
	shop_mode = false,
	sx = {},
}) {
	return (
		<Box
			position="sticky"
			top={75}
			zIndex={100}
			sx={{
				backdropFilter: "blur(10px)",
				...sx,
			}}
		>
			<Box sx={{ margin: "0 auto", width: "100%" }}>
				<Grid container columnSpacing={2}>
					{/* Breadcrumbs */}
					<Grid item xs={12}>
						<BreadcrumbsAuto shop_mode={shop_mode} />
					</Grid>

					<Grid item xs={12}>
						<Grid container alignItems="flex-start">
							{/* Title Container */}
							<Grid item xs={12} xl={8}>
								<Box
									display="flex"
									flexDirection={{ xl: "row", xs: "column" }}
									alignItems="flex-start"
								>
									<Typography
										fontSize={26}
										fontWeight={400}
										sx={{
											alignItems: "flex-start",
											display: "flex",
											minHeight: { lg: "40px" },
										}}
									>
										{title}
									</Typography>

									{(tooltip || impersonate_section) && (
										<Box
											display="flex"
											justifyContent="flex-start"
											alignItems="flex-start"
											flexWrap="nowrap"
											ml={{ xl: 2, xs: 0 }}
											mt={{ xl: 0, xs: 2 }}
											sx={{ whiteSpace: "nowrap" }}
										>
											{tooltip && (
												<Box display="flex" alignItems="flex-start">
													{tooltip}
												</Box>
											)}

											{/* Impersonate section (optional) */}
											{impersonate_section && (
												<Box display="flex" alignItems="flex-start">
													{impersonate_section}
												</Box>
											)}
										</Box>
									)}
								</Box>
							</Grid>

							{/* Actions (optional) */}
							{actions && (
								<Grid
									item
									sm={12}
									xl={4}
									sx={{
										alignItems: "flex-start",
										display: "flex",
										justifyContent: { xl: "flex-end" },
										mt: { xl: 0, xs: 1 },
										whiteSpace: "nowrap",
									}}
								>
									{actions}
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>
				{/* Navbar (optional) */}
				{navbar || <Divider sx={{ my: 2 }} />}
			</Box>
		</Box>
	);
}
